export const MU_SET_META_PROFILES = 'mutations/metaProfiles/set'
